// extracted by mini-css-extract-plugin
export default {"wrap":"Sr-z","melodyCategory":"Tr-z","fullWidth":"Ur-z","items":"Vr-z","featureCss":"Wr-z","disabled":"Xr-z","imgCss":"Yr-z"};